import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('@modules/main/main.module').then(m => m.MainModule)
  },
  {
    path: 'login',
    loadChildren: () => import('@modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'app-connect',
    loadChildren: () =>
      import('@modules/app-connect/app-connect.module').then(m => m.AppConnectModule)
  },
  {
    path: '**',
    loadChildren: () =>
      import('@modules/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule),
    title: 'Page Not Found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
